import { render, staticRenderFns } from "./FinishContact.vue?vue&type=template&id=23936fad&scoped=true"
import script from "./FinishContact.vue?vue&type=script&lang=js"
export * from "./FinishContact.vue?vue&type=script&lang=js"
import style0 from "./FinishContact.vue?vue&type=style&index=0&id=23936fad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23936fad",
  null
  
)

export default component.exports